import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    De stille epidemie: overgewicht en buikomvang in Nederland
                </title>
                <link rel="canonical" href={route("blogs.seventy-five")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="In een recent bericht werd onthuld dat maar liefst de helft van de Nederlandse bevolking kampt met overgewicht. Nog alarmerender is de voorspelling dat als deze trend zich voortzet, in 2050 twee derde van ons te zwaar zal zijn. Deze cijfers zijn niet alleen schokkend, maar ook een duidelijke waarschuwing voor de gezondheidscrisis die ons te wachten staat als we niet ingrijpen. Laten we eens dieper ingaan op de gevaren van overgewicht en een te grote buikomvang, en wat dit betekent voor onze gezondheid."
                />
                <meta
                    property="og:description"
                    content="In een recent bericht werd onthuld dat maar liefst de helft van de Nederlandse bevolking kampt met overgewicht. Nog alarmerender is de voorspelling dat als deze trend zich voortzet, in 2050 twee derde van ons te zwaar zal zijn. Deze cijfers zijn niet alleen schokkend, maar ook een duidelijke waarschuwing voor de gezondheidscrisis die ons te wachten staat als we niet ingrijpen. Laten we eens dieper ingaan op de gevaren van overgewicht en een te grote buikomvang, en wat dit betekent voor onze gezondheid."
                />
                <meta property="og:url" content={route("blogs.seventy-five")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="De stille epidemie: overgewicht en buikomvang in Nederland - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/stille-epidemie.png"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/stille-epidemie.webp"
                                    type="image/webp"
                                    alt="Stille epidemie"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/stille-epidemie.png"
                                    type="image/png"
                                    alt="Stille epidemie"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/stille-epidemie.png"
                                    alt="Stille epidemie"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        De stille epidemie: overgewicht en buikomvang in
                        Nederland
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        In een recent bericht werd onthuld dat maar liefst de
                        helft van de Nederlandse bevolking kampt met
                        overgewicht. Nog alarmerender is de voorspelling dat als
                        deze trend zich voortzet, in 2050 twee derde van ons te
                        zwaar zal zijn. Deze cijfers zijn niet alleen schokkend,
                        maar ook een duidelijke waarschuwing voor de
                        gezondheidscrisis die ons te wachten staat als we niet
                        ingrijpen. Laten we eens dieper ingaan op de gevaren van
                        overgewicht en een te grote buikomvang, en wat dit
                        betekent voor onze gezondheid.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wanneer heb je overgewicht en een te grote buikomvang?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Overgewicht wordt vaak gemeten aan de hand van de Body
                        Mass Index (BMI). Een BMI tussen 25 en 30 wijst op
                        overgewicht, terwijl een BMI boven de 30 duidt op
                        obesitas. Maar naast BMI is buikomvang een cruciale
                        indicator van gezondheidsrisico's.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Voor mannen geldt een buikomvang van meer dan 94 cm als
                        verhoogd risico, en boven de 102 cm als sterk verhoogd
                        risico. Bij vrouwen liggen deze grenzen op
                        respectievelijk 80 cm en 88 cm. Deze metingen zijn
                        belangrijk omdat buikvet, ook wel visceraal vet genoemd,
                        direct rond de organen zit en daardoor gevaarlijker is
                        dan onderhuids vet.
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Het zieke vetweefsel: meer dan alleen extra kilo's
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wat veel mensen niet beseffen, is dat overgewicht niet
                        simpelweg een kwestie is van te veel eten en te weinig
                        bewegen. Bij overgewicht wordt het vetweefsel zelf ziek.
                        Dit proces heeft verstrekkende gevolgen voor het hele
                        lichaam:
                    </p>
                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li className="mt-2">
                            Ontstekingsreacties: Ziek vetweefsel produceert
                            ontstekingsstoffen die chronische, laaggradige
                            ontstekingen in het lichaam veroorzaken.
                        </li>
                        <li className="mt-2">
                            Hormoonverstoring: Vetweefsel produceert hormonen
                            die de stofwisseling beïnvloeden, waaronder leptine
                            en adiponectine. Bij overgewicht raakt deze
                            productie verstoord.
                        </li>
                        <li className="mt-2">
                            Insulineresistentie: Ziek vetweefsel reageert minder
                            goed op insuline, wat kan leiden tot diabetes type
                            2.
                        </li>
                        <li className="mt-2">
                            Verhoogde vetopslag: Het zieke vetweefsel slaat
                            makkelijker vet op, waardoor een vicieuze cirkel
                            ontstaat.
                        </li>
                    </ol>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        De weg naar een gezonder gewicht
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het goede nieuws is dat het nooit te laat is om actie te
                        ondernemen. Zelfs een bescheiden gewichtsverlies van
                        5-10% kan al significante gezondheidsvoordelen
                        opleveren. Hier zijn enkele stappen die je kunt nemen:
                    </p>
                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li className="mt-2">
                            Voeding: Focus op een gebalanceerd dieet rijk aan
                            groenten, fruit, volkoren producten en magere
                            eiwitten.
                        </li>
                        <li className="mt-2">
                            Beweging: Streef naar minimaal 30 minuten matige
                            beweging per dag.
                        </li>
                        <li className="mt-2">
                            Slaap: Voldoende slaap is cruciaal voor een gezond
                            gewicht. Mik op 7-9 uur per nacht.
                        </li>
                        <li className="mt-2">
                            Stressmanagement: Chronische stress kan bijdragen
                            aan gewichtstoename. Vind gezonde manieren om stress
                            te verminderen.
                        </li>
                        <li className="mt-2">
                            Professionele hulp: Overweeg om een personal trainer
                            in te schakelen voor persoonlijk advies.
                        </li>
                    </ol>
                    <p className="mt-4 text-gray-100 break-words">
                        Door bewust te zijn van de risico's van overgewicht en
                        een te grote buikomvang, en door actie te ondernemen,
                        kunnen we samen werken aan een gezonder Nederland. Laten
                        we ervoor zorgen dat de voorspelling voor 2050 niet
                        uitkomt, maar in plaats daarvan een toekomst creëren
                        waarin gezondheid en vitaliteit de norm zijn.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
